var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRefresh({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-refresh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#484c52",
    d: "M27.77 7.712c-0.624-0.079-1.163 0.35-1.242 0.955l-0.389 2.994c-2.094-3.952-6.159-6.441-10.721-6.441-6.702 0-12.154 5.451-12.154 12.151 0 6.702 5.452 12.154 12.154 12.154 2.436 0 4.784-0.718 6.794-2.075 0.507-0.342 0.641-1.031 0.298-1.538-0.341-0.505-1.031-0.641-1.538-0.298-1.642 1.109-3.563 1.695-5.553 1.695-5.479 0-9.938-4.458-9.938-9.937 0-5.478 4.459-9.936 9.938-9.936 3.812 0 7.183 2.137 8.86 5.492l-2.978-1.169c-0.57-0.222-1.211 0.058-1.436 0.628-0.224 0.569 0.057 1.211 0.626 1.435l5.914 2.321c0.13 0.052 0.268 0.078 0.405 0.078 0.196 0 0.39-0.053 0.564-0.155 0.293-0.174 0.49-0.473 0.535-0.81l0.818-6.299c0.079-0.61-0.35-1.166-0.956-1.244z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefresh);
export default __webpack_public_path__ + "static/media/icon-refresh.6e03970b.svg";
export { ForwardRef as ReactComponent };